import React from 'react'
import { ScrollView, View, Platform, Button } from 'react-native'
import Signature from 'react-native-signature-canvas'
import SignatureCanvas from 'react-signature-canvas'

import {
  Control,
  FieldErrors,
  FieldName,
  FieldValues,
  SetFieldValue,
  SetValueConfig,
  useController,
} from 'react-hook-form'
import { ChoiceTypeField } from './ChoiceTypeField/ChoiceTypeField'
import { OpenTypeField } from './OpenTypeField/OpenTypeField'
import { Question, QuestionContainer, QuestionNumber } from './style'

type QuestionType = 'open' | 'choice' | 'condition' | 'signature'

type Props = {
  id: string
  question: string
  highlight: string
  bgcolor: string
  fontcolor: string
  type: QuestionType
  isMultiline?: boolean
  isMultipleChoice?: boolean
  choices: string[]
  number: number
  control: Control<FieldValues>
  errors: FieldErrors<FieldValues>
  signatureRef: React.RefObject<SignatureCanvas>
  setValue: (
    name: FieldName<FieldValues>,
    value: SetFieldValue<FieldValues>,
    config?: SetValueConfig
  ) => void
}

export const QuestionCard = ({
  highlight,
  bgcolor,
  number,
  type,
  question,
  id,
  fontcolor,
  isMultiline,
  isMultipleChoice,
  choices,
  control,
  errors,
  setValue,
  signatureRef,
}: Props) => {
  const { field } = useController({
    name: id,
    control,
    defaultValue: {},
  })

  const questionCardInput = () => {
    if (type === 'signature') {
      const canvasProps = {
        style: { border: '1px solid green' },
      }
      if (Platform.OS === 'web') {
        return (
          <>
            <SignatureCanvas
              backgroundColor="rgba(255,255,255,1)"
              onEnd={() => {
                const URL = signatureRef.current
                  .getTrimmedCanvas()
                  .toDataURL('image/png')
                field.onChange(URL)
                setValue('signature', URL, { shouldValidate: false })
              }}
              canvasProps={canvasProps}
              ref={signatureRef}
            />
            <Button
              title="Reset"
              onPress={() => signatureRef.current.clear()}
            />
          </>
        )
      }
      return (
        <Signature backgroundColor="rgba(255,255,255,1)" ref={signatureRef} />
      )
    }
    if (type === 'open' || type === 'condition') {
      return (
        <OpenTypeField
          fontcolor={fontcolor}
          isMultiline={isMultiline}
          control={control}
          errors={errors}
          questionId={id}
          inputType={type}
        />
      )
    }
    return (
      <ChoiceTypeField
        fontcolor={fontcolor}
        isMultipleChoice={isMultipleChoice}
        choices={choices}
        control={control}
        questionId={id}
        setValue={setValue}
      />
    )
  }

  return (
    <View>
      <QuestionContainer>
        <QuestionNumber highlight={highlight} bgcolor={bgcolor}>
          {number}
        </QuestionNumber>
        {type === 'condition' ? (
          <ScrollView>
            <Question fontcolor={fontcolor}>{question}</Question>
          </ScrollView>
        ) : (
          <Question fontcolor={fontcolor}>{question}</Question>
        )}
      </QuestionContainer>
      <View>{questionCardInput()}</View>
    </View>
  )
}
